import { render } from "./ContactUsComponent.vue?vue&type=template&id=1f5b84d7&scoped=true"
import script from "./ContactUsComponent.vue?vue&type=script&lang=js"
export * from "./ContactUsComponent.vue?vue&type=script&lang=js"

import "./ContactUsComponent.vue?vue&type=style&index=0&id=1f5b84d7&lang=scss&scoped=true"

import exportComponent from "E:\\dive\\dive.fsd.vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f5b84d7"]])

export default __exports__